import React, { FC } from 'react';
import { NavLink, ExtraInfo } from './styles';
import { Props, PropsNotRouted } from './types';

export const NotRoutedTab: FC<PropsNotRouted> = ({
  label,
  size,
  selected,
  ...props
}) => {
  return (
    <NavLink
      as="div"
      $size={size}
      {...props}
      className={selected ? 'selected' : undefined}
    >
      {label}
    </NavLink>
  );
};

const Tab: FC<Props> = ({ label, extraInfo, size, ...props }) => {
  return (
    <NavLink $size={size} activeClassName="selected" {...props}>
      {label} <ExtraInfo>{extraInfo}</ExtraInfo>
    </NavLink>
  );
};

export default Tab;
